var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"JournalistDashboardLink NavLink",attrs:{"to":_vm.$i18nRoute({ name: 'dashboard' })}},[_c('i',{staticClass:"hf hf-dashboard hf-fw hf-lg"}),_vm._v(" "+_vm._s(_vm.$t('components.top_nav.dashboard'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }